import * as React from 'react';
import { Controller, IDynamicLoader, Loader, Menu, Toolbar } from '@tencent/workbench';
import { config, MENU_CONFIGS, TOOLBAR_ITEMS } from './config';
import { wrapIdForBig } from '@src/framework/workbench/util/wrap-id-util';
import { IInsertTemplateFeature } from './insert-template-slide-interface';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class InsertTemplateSlideController {
    public constructor(@Loader(IInsertTemplateFeature) private loader: IDynamicLoader<IInsertTemplateFeature>) {
    }

    private get feature() {
        return this.loader.instance!;
    }

    @Toolbar(wrapIdForBig(config.id), 'dropdownContent')
    @Menu(`${config.id}-drop-content`, 'content')
    public getInsertTemplateSlideDropdownContent() {
        return this.feature.getInsertTemplateSlideDropdownContent();
    }

    @Toolbar(wrapIdForBig(config.id), 'shouldHide')
    public shouldHide() {
        return this.feature.shouldHide();
    }
}
